/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdSideBarProps } from './type';
const props: TdSideBarProps = {
  /** 选项值 */
  value: {
    type: null,
    value: null,
  },
  /** 选项值，非受控属性 */
  defaultValue: {
    type: null,
  },
};

export default props;
